// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopThirdPartyTicketControllerGetThirdPartyTicketsData } from './EshopThirdPartyTicketControllerGetThirdPartyTicketsData.gen';
import type { EshopThirdPartyTicketControllerGetThirdPartyTicketsErrors } from './EshopThirdPartyTicketControllerGetThirdPartyTicketsErrors.gen';
import type { EshopThirdPartyTicketControllerGetThirdPartyTicketsResponses } from './EshopThirdPartyTicketControllerGetThirdPartyTicketsResponses.gen';
import type { Options } from './Options.gen';

export class EshopThirdPartyTicketController {
    /**
     * Get third party tickets.
     */
    public static getThirdPartyTickets<ThrowOnError extends boolean = false>(options?: Options<EshopThirdPartyTicketControllerGetThirdPartyTicketsData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopThirdPartyTicketControllerGetThirdPartyTicketsResponses, EshopThirdPartyTicketControllerGetThirdPartyTicketsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/third-party-tickets',
            ...options
        });
    }
}
